// extracted by mini-css-extract-plugin
export var border = "textandtext-module--border--bd386";
export var containerHeader = "textandtext-module--containerHeader--46c1b";
export var containerHeaderBox = "textandtext-module--containerHeaderBox--6b083";
export var containerSubHeader = "textandtext-module--containerSubHeader--4a673";
export var dataAndInsightsImage = "textandtext-module--dataAndInsightsImage--51fa2";
export var greenAnchor = "textandtext-module--greenAnchor--df574";
export var heading = "textandtext-module--heading--927a8";
export var leftColumnCard = "textandtext-module--leftColumnCard--83bb2";
export var leftColumnCardBody = "textandtext-module--leftColumnCardBody--86987";
export var leftColumnCardBox = "textandtext-module--leftColumnCardBox--6cd85";
export var leftColumnCardTitle = "textandtext-module--leftColumnCardTitle--e76b5";
export var leftColumnHeader = "textandtext-module--leftColumnHeader--401c6";
export var leftColumnLink = "textandtext-module--leftColumnLink--059b3";
export var leftColumnLinkContainer = "textandtext-module--leftColumnLinkContainer--d93f5";
export var leftColumnSubHeading = "textandtext-module--leftColumnSubHeading--e4fa4";
export var leftColumnSubTitle = "textandtext-module--leftColumnSubTitle--85847";
export var leftColumnTitle = "textandtext-module--leftColumnTitle--660f8";
export var listCheckIcon = "textandtext-module--listCheckIcon--45a40";
export var noSubHeading = "textandtext-module--noSubHeading--19454";
export var noSubHeadingChooseBox = "textandtext-module--noSubHeadingChooseBox--616f0";
export var philRxAccessSolutionNoBorder = "textandtext-module--philRxAccessSolutionNoBorder--818bc";
export var philRxAccessSolutionPageImage = "textandtext-module--philRxAccessSolutionPageImage--f99eb";
export var rightColumn = "textandtext-module--rightColumn--b247f";
export var rightColumnContainer = "textandtext-module--rightColumnContainer--3d2f6";
export var rightColumnHeader = "textandtext-module--rightColumnHeader--d35c9";
export var subHeading = "textandtext-module--subHeading--66ad2";